<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="名称" prop="name">
            <el-input placeholder="请输入名称" v-model="rule.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="国家" prop="countryId">
            <el-select v-model="rule.countryId">
                <el-option value="" label="请选择国家"></el-option>
                <el-option v-for="x in selectList" :key="x.id" :value="x.id" :label="x.name"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="联系人姓名" prop="contactName">
            <el-input placeholder="请输入联系人姓名" v-model="rule.contactName" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="contactMobile">
            <el-input placeholder="请输入联系人电话" v-model="rule.contactMobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人地址" prop="contactAddr">
            <el-input placeholder="请输入联系人地址" v-model="rule.contactAddr" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入描述" v-model="rule.desc" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            var validPhone = (rule,value,callback) => {
                if (!/^1[3456789]\d{9}$/.test(value)) {
                    callback(new Error("请输入正确的手机号"));
                } else {
                    callback();
                }
            }
            return {
                name: 'edit',
                rule: {
                    id: 0,
                    name: '',
                    countryId: '',
                    contactName: '',
                    contactMobile: '',
                    contactAddr: '',
                    desc: '',
                },
                rules: {
                    name: {required: true, message: '请输入名称'},
                    countryId: { required: true, message: '请选择国家',trigger:'blur'},
                    contactName: { required: true, message: '请输入联系人姓名' },
                    contactMobile: [{ required: true, message: '请输入联系人电话' },
                    {validator: validPhone,trigger:'blur'}],
                    contactAddr: { required: true, message: '请输入联系人地址' },
                    desc: {required: true, message: '请输入描述'},
                },
                selectList:[]
            }
        },
        async created() {
            this.$http.get('/manage/country/listAll').then(results => {
                this.selectList = results['data']['data'];
            });
            if(this.$route.params.id) {
                if(!!this.$store.state.editInfo) {
                    this.rule = this.$store.state.editInfo
                    this.rule.countryId = this.$store.state.editInfo.country.id;
                }else {
                    this.$router.push('/sim/gys');
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        if(this.rule.id == 0) {
                            this.$http.post('/manage/supplier/add',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/sim/gys');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.$http.post('/manage/supplier/edit',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/sim/gys');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                        
                    }
                });
            },
            block() {
                this.$router.push('/sim/gys');
            },
        }
    }
</script>